import { useOrder, whiteGloveFee } from "../../context/OrderContext";
import { ShieldCheck, Check } from "lucide-react";

/**
 * "White Glove Measurement & Perfect Fit Guarantee" upsell.
 * Shown only when product=window AND quantity>=3.
 */
export default function StepWhiteGlove() {
  const { state, update, goNext, goBack } = useOrder();
  const qty = state.quantity || 1;
  const fee = whiteGloveFee(state.product?.type, qty, true);

  const choose = (yes) => {
    update({ whiteGlove: yes });
    goNext();
  };

  return (
    <div data-testid="step-white-glove">
      <div className="flex items-center gap-2 mb-2">
        <ShieldCheck className="w-7 h-7 brand-text" />
        <span className="text-xs font-bold uppercase tracking-wider brand-text">
          Perfect Fit Guarantee
        </span>
      </div>

      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-2 text-[var(--brand-text)]">
        Want us to handle everything?
      </h1>
      <p className="muted-text mb-5">
        We come out, professionally measure every screen, and guarantee a perfect fit —
        no guesswork, no risk.
      </p>

      <div className="option-card mb-4">
        <ul className="space-y-2">
          <li className="flex items-start gap-2 text-sm" data-testid="wg-bullet-1">
            <Check className="w-5 h-5 brand-text mt-0.5 shrink-0" /> We measure every screen
          </li>
          <li className="flex items-start gap-2 text-sm" data-testid="wg-bullet-2">
            <Check className="w-5 h-5 brand-text mt-0.5 shrink-0" /> Built to exact fit
          </li>
          <li className="flex items-start gap-2 text-sm" data-testid="wg-bullet-3">
            <Check className="w-5 h-5 brand-text mt-0.5 shrink-0" /> No mistakes or reorders
          </li>
        </ul>
        <div className="mt-4 pt-3 border-t border-[var(--brand-border)] flex items-baseline justify-between">
          <span className="text-sm muted-text">For your {qty} screens</span>
          <span className="text-2xl font-black text-[var(--brand-text)]" data-testid="wg-price">
            +${fee}
          </span>
        </div>
      </div>

      <div className="flex gap-3">
        <button data-testid="wg-no-btn" type="button" onClick={() => choose(false)}
          className="flex-1 py-3 rounded-full border-2 border-[var(--brand-border)] font-semibold">
          No Thanks
        </button>
        <button data-testid="wg-yes-btn" type="button" onClick={() => choose(true)}
          className="cta-btn flex-1">
          Yes, Add Guarantee
        </button>
      </div>

      <button data-testid="back-btn" type="button" onClick={goBack}
        className="block mx-auto mt-4 text-xs muted-text underline-offset-2 hover:underline">
        Back
      </button>
    </div>
  );
}
